/* VELTO Atelier — theme scripts */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '¥{{amount_no_decimals}}';
    function fmt(n, decimals, thousands, decimal) {
      var v = (n / 100).toFixed(decimals).split('.');
      v[0] = v[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return v[1] ? v[0] + decimal + v[1] : v[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* drawer */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    function set(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* announcement rotator */
  function initRotators() {
    $$('[data-rotator]').forEach(function (el) {
      var items = $$('[data-rotator-item]', el);
      if (items.length < 2 || reduced) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, (parseInt(el.dataset.speed, 10) || 5) * 1000);
    });
  }

  /* hero slideshow */
  function initSlideshows() {
    $$('[data-slideshow]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var slides = $$('[data-slide]', el);
      var dots = $$('[data-slide-to]', el);
      if (slides.length < 2) return;
      var i = 0, timer = null;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function play() {
        stop();
        if (el.dataset.autoplay !== 'true' || reduced) return;
        timer = setInterval(function () { go(i + 1); }, (parseInt(el.dataset.speed, 10) || 6) * 1000);
      }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.slideTo, 10)); play(); }); });
      var prev = $('[data-slide-prev]', el), next = $('[data-slide-next]', el);
      if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
      if (next) next.addEventListener('click', function () { go(i + 1); play(); });
      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', play);
      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) { go(dx < 0 ? i + 1 : i - 1); play(); }
        x0 = null;
      }, { passive: true });
      /* テーマエディタでブロック選択時にそのスライドを表示 */
      el.addEventListener('shopify:block:select', function (e) { stop(); go(slides.indexOf(e.target)); });
      play();
    });
  }

  /* tabs */
  function initTabs() {
    $$('[data-tabs]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var tabs = $$('[data-tab]', el), panels = $$('[data-panel]', el);
      function show(n) {
        tabs.forEach(function (t) { var on = t.dataset.tab === String(n); t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.dataset.panel !== String(n); });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.dataset.tab); });
        t.addEventListener('shopify:block:select', function () { show(t.dataset.tab); });
      });
    });
  }

  /* product page */
  function initProducts() {
    $$('[data-product]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      function showMedia(id) {
        var found = false;
        $$('.pd__item', el).forEach(function (m) { var on = m.dataset.mediaId === String(id); if (on) found = true; });
        if (!found) return;
        $$('.pd__item', el).forEach(function (m) { m.classList.toggle('is-active', m.dataset.mediaId === String(id)); });
        $$('[data-thumb]', el).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
      }
      $$('[data-thumb]', el).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });

      var qty = $('[data-qty]', el);
      if (qty) {
        var input = $('input', qty);
        $('[data-qty-minus]', qty).addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
        $('[data-qty-plus]', qty).addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      }

      var json = $('[data-variants]', el);
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var idInput = $('[data-variant-id]', el), priceEl = $('[data-price]', el), addBtn = $('[data-add]', el), label = $('[data-add-label]', el);
      function update() {
        var chosen = [];
        $$('[data-option]:checked', el).forEach(function (r) { chosen[parseInt(r.dataset.option, 10)] = r.value; });
        var v = variants.filter(function (x) { return x.options.every(function (o, k) { return o === chosen[k]; }); })[0];
        if (!v) { addBtn.disabled = true; label.textContent = label.dataset.labelSold; return; }
        idInput.value = v.id;
        addBtn.disabled = !v.available;
        label.textContent = v.available ? label.dataset.labelAdd : label.dataset.labelSold;
        priceEl.innerHTML = v.compare_at_price > v.price
          ? '<span class="price__now price__now--sale">' + formatMoney(v.price) + '</span><s class="price__was">' + formatMoney(v.compare_at_price) + '</s>'
          : '<span class="price__now">' + formatMoney(v.price) + '</span>';
        if (v.featured_media) showMedia(v.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      $$('[data-option]', el).forEach(function (r) { r.addEventListener('change', update); });
    });
  }

  /* collection sort */
  function initSort() {
    $$('[data-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* product recommendations */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length || !el.dataset.url) { if (!el.children.length) el.hidden = true; return; }
      el.hidden = true;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.children.length) { el.innerHTML = fresh.innerHTML; el.hidden = false; }
      }).catch(function () {});
    });
  }

  function init() {
    initDrawer(); initRotators(); initSlideshows(); initTabs(); initProducts(); initSort(); initRecommendations();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initSlideshows(); initTabs(); initProducts(); initRecommendations(); });
})();
